(function ($) {
    'use strict';
    $(function () {

        const filterContainer = $('.js-filter-section');

        if (!filterContainer.length) {
            return;
        }


        /* Get URL paremeters */
        var filterDates = $.getUrlParameter('napok');
        if (filterDates != undefined && filterDates != "") {
            var dates = filterDates.split(',');
            $.each(dates, function (i, val) {
                var currentItem = $(`.js-filter-select--private-walk-dates option[value=${val}]`);
                currentItem.attr('selected', true);
            });
        }

        var filterPlaces = $.getUrlParameter('helyszinek');
        if (filterPlaces != undefined && filterPlaces != "") {
            var places = filterPlaces.split(',');
            $.each(places, function (i, val) {
                var currentItem = $(`.js-filter-select--private-walk-places option[value=${val}]`);
                currentItem.attr('selected', true);
            });
        }

        var filterLengths = $.getUrlParameter('idotartam');
        if (filterLengths != undefined && filterLengths != "") {
            var lengths = filterLengths.split(',');
            $.each(lengths, function (i, val) {
                var currentItem = $(`.js-filter-select--private-walk-lengths option[value=${val}]`);
                currentItem.attr('selected', true);
            });
        }

        /* Init filter controls */
        const datesFilter = $('.js-filter-select--private-walk-dates');
        const placeFilter = $('.js-filter-select--private-walk-places');
        const lengthFilter = $('.js-filter-select--private-walk-lengths');

        datesFilter.SumoSelect({
            placeholder: "Napok",
            captionFormat: "{0} nap kiválasztva",
            captionFormatAllSelected: "Összes nap kiválasztva"
        });

        datesFilter.on('change', function () {
            let currentValue = $(this).val();
            let closestFilter = $(this).closest('.js-filter');
            let currentType = closestFilter.data('type');

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));

            updateList();
        });

        placeFilter.SumoSelect({
            placeholder: "Helyszínek",
            captionFormat: "{0} helyszín kiválasztva",
            captionFormatAllSelected: "Összes helyszín kiválasztva"
        });

        placeFilter.on('change', function () {
            let currentValue = $(this).val();
            let closestFilter = $(this).closest('.js-filter');
            let currentType = closestFilter.data('type');

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));
            updateList();
        });

        lengthFilter.SumoSelect({
            placeholder: "Időtartam",
            captionFormat: "{0} időtartam kiválasztva",
            captionFormatAllSelected: "Összes időtartam kiválasztva"
        });

        lengthFilter.on('change', function () {
            let currentValue = $(this).val();
            let closestFilter = $(this).closest('.js-filter');
            let currentType = closestFilter.data('type');

            history.pushState({}, null, $.replaceUrlParam(window.location.href, currentType, currentValue));
            updateList();
        });

        var filterInstance = [];
        var filterOptions = {
            valueNames: [{
                data: ['date', 'place', 'len']
            }]
        };

        $('.js-private-walks-list').each(function (i, e) {
            filterInstance.push(new List(e, filterOptions));
        });


        /* If filter page has url paremeters then update list */
        if (filterDates || filterPlaces || filterLengths) {
            updateList();
        }

        function updateList() {
            let valueDates = $('.js-filter-select--private-walk-dates').val();
            let valuePlaces = $('.js-filter-select--private-walk-places').val();
            let valueLengths = $('.js-filter-select--private-walk-lengths').val();

            $.each(filterInstance, (i, e) => {
                var privateWalksList = e;

                privateWalksList.filter(function (item) {
                    let datesFilter = false;
                    let placesFilter = false;
                    let lengthsFilter = false;

                    if (valueDates.length == 0) {
                        datesFilter = true;
                    } else {
                        datesFilter = valueDates.some(a => item.values().date.includes(a));
                    }

                    if (valuePlaces.length == 0) {
                        placesFilter = true;
                    } else {
                        placesFilter = valuePlaces.some(a => item.values().place.includes(a));
                    }

                    if (valueLengths.length == 0) {
                        lengthsFilter = true;
                    } else {
                        lengthsFilter = valueLengths.some(a => item.values().len.includes(a));
                    }

                    return datesFilter && placesFilter && lengthsFilter;
                });

                privateWalksList.update();

                if (!privateWalksList.matchingItems.length > 0) {
                    $('.js-no-result').removeClass("d-none")
                } else {
                    $('.js-no-result').addClass("d-none")
                }

            });
        }
    });
})(jQuery);